















export default {
  name: 'MoreIcon',
  props: {
    small:Boolean,
    alt:Boolean
  }

};
